import Image from "next/image";

export default function Leadership() {
  return (
    <section className="container pt-3">
      {/* Top Leader */}
      <div className="row align-items-start mb-5">
        <div className="col-md-3 mb-1 mb-md-0 d-flex justify-content-center">
          <Image
            src="/images/management/GauravPallial.jpeg"
            width={300}
            height={300}
            alt="Leader"
            className="img-fluid"
            sizes="(max-width: 768px) 60vw, 300px"
          />
        </div>

        <div className="col-md-9">
          <h3 className="fw-bold !text-[18px] text-center text-md-start mb-1">
            GAURAV PALLIAL
          </h3>
          <p className="fw-semibold small text-center text-md-start">
            CHAIRMAN & MANAGING DIRECTOR
          </p>
          <p className="text-muted !text-[14px] text-center text-md-start">
            Gaurav Pallial, the Chairman and the Managing Director of Orange
            Tiger Hospitality Pvt. Ltd., is a seasoned professional with
            extensive expertise in strategic planning, profit-center hotel
            operations, renovation management, training & development,
            budgeting, marketing, and guest relationship management.
          </p>
          <p className="text-muted !text-[14px] text-center text-md-start">
            Before establishing OTHPL, he was the CEO of Kyriad Hotels for over
            7 years, and earlier the CEO of Citrus Hotels & Resorts, where he
            built strong teams, improved profitability, and expanded the brand.
            He also served as COO and VP at Citrus Hotels & Resorts, driving new
            hotel openings, branding, marketing, and overall business
            development.
          </p>
          <p className="text-muted !text-[14px] text-center text-md-start">
            Earlier in his career, Gaurav Pallial worked with Lemon Tree Hotels,
            where he helped open and manage flagship properties making them
            market leaders. He began his journey with the Ashok Group of Hotels,
            Jaypee Hotels, ITC Maurya Sheraton, and Hans Plaza, gaining valuable
            experience in luxury operations, banquets, boutique hotels, and
            large scale events.
          </p>
        </div>
      </div>

      {/* Bottom Leaders */}
      <div className="row text-center">
        {/* Card 1 */}
        <div className="col-md-4 mb-4">
          <Image
            src="/images/management/KurianVarghese.jpeg"
            width={300}
            height={300}
            alt="Leader"
            className="img-fluid mb-3 mx-auto"
            sizes="(max-width: 768px) 60vw, 300px"
          />
          <h5 className="fw-bold">KURIAN VARGHESE</h5>
          <p className="fw-semibold small mb-2">
            CO-FOUNDER & CHIEF EXECUTIVE OFFICER (CEO)
          </p>
          <p className="text-muted small text-left">
            Kurian Varghese serves as CEO of Orange Tiger Hospitality Pvt. Ltd. He steers
            the company&apos;s strategic vision, operations, and business development
            in hotel management and allied services.
          </p>
          <p className="text-muted small text-left">
            At Orange Tiger Hospitality, he spearheads efforts to broaden the
            company&apos;s reach, forge strategic partnerships, and amplify its
            presence in India&apos;s hospitality landscape. Kurian represents the
            firm at key industry events and collaborations, driving growth and
            operational excellence.
          </p>
        </div>

        {/* Card 2 */}
        <div className="col-md-4 mb-4">
          <Image
            src="/images/management/ShaleenMathur.jpeg"
            width={300}
            height={300}
            alt="Leader"
            className="img-fluid mb-3 mx-auto"
            sizes="(max-width: 768px) 60vw, 300px"
          />
          <h5 className="fw-bold">SHALEEN MATHUR</h5>
          <p className="fw-semibold small mb-2">
            CO-FOUNDER & CHIEF REVENUE OFFICER
          </p>
          <p className="text-muted small text-left">
            Shaleen Mathur serves as Chief Revenue Officer at Orange Tiger
            Hospitality Pvt. Ltd., leveraging over two decades of hospitality
            expertise. He drives revenue growth, crafts sales strategies, and
            strengthens the company&apos;s market position.
          </p>
          <p className="text-muted small text-left">
            At Orange Tiger Hospitality, Shaleen leads revenue planning, key
            partnerships, and business expansion across diverse hospitality
            segments. His strong expertise in sales leadership and revenue
            management drives the company’s growth.
          </p>
        </div>

        {/* Card 3 */}
        <div className="col-md-4 text-center">
          <Image
            src="/images/management/SohanChauhan.jpeg"
            width={300}
            height={300}
            alt="Leader"
            className="img-fluid mb-3 mx-auto"
            sizes="(max-width: 768px) 60vw, 300px"
          />
          <h5 className="fw-bold">SOHAN SINGH CHAUHAN</h5>
          <p className="fw-semibold small mb-2">
            CO-FOUNDER & PRESIDENT - FINANCE
          </p>
          <p className="text-muted small text-left">
            Sohan Singh Chauhan serves as President of Finance at Orange Tiger
            Hospitality Pvt. Ltd. With extensive experience in finance and
            accounting leadership across the hospitality sector, he brings deep
            expertise in financial strategy and organizational management.
          </p>
          <p className="text-muted small text-left">
            At Orange Tiger Hospitality Pvt. Ltd., Sohan oversees the financial
            operations and directs the financial strategies specific to the
            industry.
          </p>
        </div>
      </div>
    </section>
  );
}
